'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Select = function (_React$Component) {
  _inherits(Select, _React$Component);

  function Select(props) {
    _classCallCheck(this, Select);

    var _this = _possibleConstructorReturn(this, (Select.__proto__ || Object.getPrototypeOf(Select)).call(this, props));

    _this.onKeyPressed = _this.onKeyPressed.bind(_this);
    return _this;
  }

  _createClass(Select, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      window.addEventListener('keydown', this.onKeyPressed);
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      window.removeEventListener('keydown', this.onKeyPressed);
    }
  }, {
    key: 'render',
    value: function render() {
      var children = this.props.children;


      return _react2.default.createElement(
        'div',
        null,
        children
      );
    }
  }, {
    key: 'onKeyPressed',
    value: function onKeyPressed(e) {
      var _props = this.props;
      var rows = _props.rows;
      var selectedRowIndex = _props.selectedRowIndex;
      var onSelectRow = _props.onSelectRow;

      // No selection yet, escape

      if (selectedRowIndex < 0) {
        return;
      }

      // Arrow Up
      if (e.keyCode === 38 && selectedRowIndex > 0) {
        e.preventDefault();

        onSelectRow(selectedRowIndex - 1);
      }

      // Arrow Down
      if (e.keyCode === 40 && selectedRowIndex < rows.length - 1) {
        e.preventDefault();

        onSelectRow(selectedRowIndex + 1);
      }
    }
  }]);

  return Select;
}(_react2.default.Component);

process.env.NODE_ENV !== "production" ? Select.propTypes = {
  children: _react2.default.PropTypes.any.isRequired,
  selectedRowIndex: _react2.default.PropTypes.any,
  onSelectRow: _react2.default.PropTypes.func.isRequired,
  // TODO: Same as for table but this is enough for now
  // -> extract reactabular-types?
  rows: _react2.default.PropTypes.any.isRequired
} : void 0;
Select.defaultProps = {
  onSelectRow: function onSelectRow() {}
};

exports.default = Select;


//////////////////
// WEBPACK FOOTER
// ./~/reactabular-select/dist/Select.js
// module id = 1402
// module chunks = 0